import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core';
import { IExcedenteItem } from '@model/ExcedenteItem';
import React from 'react';
import { TableKeyCell } from '@components/Table/TableKeyCell';


export type ExcedenteDetalheTableProps = {
    data: IData<IExcedenteItem>
}

export function ExcedenteDetalheTable ({ data }: ExcedenteDetalheTableProps) {
    const formatter = useFormatter();

    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>Número</TableCell>
                    <TableCell>Descrição</TableCell>
                    <TableCell>Valor</TableCell>
                </TableRow>
            </TableHead>

            <TableBody>
                {
                    data.items.map(excedenteItem => {
                        return (
                            <TableRow>
                                <TableKeyCell>{excedenteItem.excedenteItemId}</TableKeyCell>
                                <TableCell>{formatter.toCelular(excedenteItem.numero)}</TableCell>
                                <TableCell>{excedenteItem.descricao}</TableCell>
                                <TableCell>{formatter.toFloat(excedenteItem.valor)}</TableCell>
                            </TableRow>
                        )
                    })
                }
            </TableBody>
        </Table>
    )
}